import { helper } from '@ember/component/helper';
import { format } from 'd3-format';

export function formatCurrency([number], { precision = 2 } = {}) {
  let f = format(`,.${precision}f`);

  return `$${f((number || 0) / 100)}`;
}

export default helper(formatCurrency);
